export default __webpack_public_path__ + "static/media/alplat_logo.80644b2c.svg";